import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { InputText } from "primereact/inputtext";
import {
  GeneratePaymentLink,
  getStorePaymentGatewayConfig,
} from "../../services/PaymentGatewayConfig/PaymentGatewayConfig";
import { Dialog } from "primereact/dialog";
import { getLocalStorePaymentGatewayConfig } from "../../utils/localStorage";
import { ReGenerateSubscriptionPaymentLink } from "../../services/CustomerPackageOffer/CustomerPackageOffer";

const PaymentGatewayLinkGenerateModalAdmin = ({
  paymentGatewayLinkGenerateModalVisible,
  setPaymentGatewayLinkGenerateModalVisible,
  receiveAmountValue,
  storeCustomerId,
  storeId,
  brandId,
  storeUserId,
  bookingOrderId,
}) => {
  const [responseData, setResponseData] = useState({});
  const [amountData, setAmountData] = useState("");
  const [errorText, setErrorText] = useState("");
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [storePaymentGatewayData, setStorePaymentGatewayData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [resendPaymentLink, setResendPaymentLink] = useState(false)
  const [paymentLinkRes, setPaymentLinkRes] = useState({})
  const [paymentLinkReGenerationRes, setPaymentLinkReGenerationRes] = useState({})

  const fetchStorePaymentGatewayConfig = async () => {
    try {
      const response = await getStorePaymentGatewayConfig(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStorePaymentGatewayData(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  useEffect(() => {
    setAmountData(receiveAmountValue.toString());
    fetchStorePaymentGatewayConfig();
  }, [paymentGatewayLinkGenerateModalVisible]);

  // Initialize a state variable for storing pickup requests
  // const [authCodeError, setAuthCodeError] = useState('');

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  // const handleAuthCodeChange = text => {
  //   setAuthCodeValue(text);
  // };

  const handleAmountChange = (text) => {
    if (!text) {
      setAmountData("");
      setErrorText("Charge Count cannot be empty or zero");
      setIsPayNowButtonPressed(true);
    } else if (parseInt(text) <= parseInt(0)) {
      setErrorText("Count Can't Be Less Then Or Equal to Zero");
      setAmountData(text);
      setIsPayNowButtonPressed(true);
    } else if (parseInt(text) > parseInt(receiveAmountValue)) {
      setErrorText(
        "Entered Value Can Not Be Greater Then " +
        receiveAmountValue?.toFixed(0)
      );
      setAmountData(text);
      setIsPayNowButtonPressed(true);
    } else {
      setAmountData(text);
      setErrorText("");
      setIsPayNowButtonPressed(false);
    }
  };

  const handleCollectPayment = () => {
    if (!isPayNowButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsPayNowButtonPressed(true);
      const gatewayData = {
        storeGatewayId: storePaymentGatewayData[0]?.id,
        storeCustomerId: storeCustomerId,
        orderId: bookingOrderId,
        requestAmount: amountData,
        notify: true,
        storeUserId: storeUserId,
        forceCreate: false,
      };
      GeneratePaymentLink(gatewayData)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            // setResponseData(Res);
            // setIsPayNowButtonPressed(false);
            if (Res) {
              setPaymentLinkRes(Res)
              const message = Res.message;
              const status = Res.status;

              if (status === true && message === "Success") {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
                setTimeout(() => {
                  setResponseData(Res);
                  setIsPayNowButtonPressed(false);
                  setPaymentGatewayLinkGenerateModalVisible(false);
                  setErrorText("");
                  setAmountData("");
                }, 2000);
              } else if (message === "Already exist!") {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
                setResendPaymentLink(true)
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
                setTimeout(() => {
                  setResponseData(Res);
                  setIsPayNowButtonPressed(false);
                  setPaymentGatewayLinkGenerateModalVisible(false);
                  setErrorText("");
                  setAmountData("");
                }, 2000);
              }


            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handleModalClose = () => {
    setPaymentGatewayLinkGenerateModalVisible(false);
    setIsPayNowButtonPressed(false);
    setErrorText("");
    setAmountData("");
    setResponseData("");
    setResendPaymentLink(false)
    setPaymentLinkRes({})
    setPaymentLinkReGenerationRes({})
  };

  const handleSubscriptionPaymentLinkReGeneration = (paymentLinkRes) => {

    const id = paymentLinkRes.resCode

    ReGenerateSubscriptionPaymentLink(id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          if (Res) {
            setPaymentLinkReGenerationRes(Res)
            const message = Res.message;
            const status = Res.status;
            // setResponseData(Res);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={paymentGatewayLinkGenerateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!paymentGatewayLinkGenerateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"images/cashless-payment.png"}
                  style={{
                    width: 50,
                    // height: 40,
                  }}
                />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Payment Link
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            {resendPaymentLink ?

              <>

                <div className=" flex flex-column">
                  {paymentLinkReGenerationRes.resCode ? <div className="m-4">

                    <p className="text-lg text-center font-semibold">Payment Link {paymentLinkReGenerationRes.message}</p>
                    <p className="text-xl text-center font-semibold" style={{ color: 'blue' }}>{paymentLinkReGenerationRes.resCode}</p>
                  </div>
                  :
                  <div className="flex justify-content-between">

                    <Button
                      onClick={() => handleSubscriptionPaymentLinkReGeneration(paymentLinkRes)}
                      className="mt-1 mb-3 mx-4 border-round-xl w-full"
                    >
                      <p className=" w-full text-2xl font-semibold flex justify-content-center">
                        Re-Generate Link
                      </p>
                    </Button>
                  </div>
                  }
                </div>

              </> :
              Object.keys(responseData).length > 0 ? (
                <div className="mx-3 my-2">
                  <p
                    className="text-2xl font-semibold text-center"
                    style={{ color: "red" }}
                  >
                    {responseData.status
                      ? "Payment Link Generate Please check Notifications"
                      : responseData.paymentLink !== ""
                        ? "Payment Link is already Generated"
                        : "Payment Link Failed"}
                  </p>
                </div>
              ) : (
                <div className="flex flex-column">
                  <div >
                    <p className="text-2xl font-semibold text-center">
                      {
                        storePaymentGatewayData[0]?.brandPaymentGatewayInfo
                          .gatewayName
                      }
                    </p>
                  </div>

                  <div className=" mx-4">
                    <div>
                      <p>Amount</p>
                      <InputText
                        className="w-full text-xl h-3rem border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                        value={amountData}
                        onChange={(e) => handleAmountChange(e.target.value)}
                        keyboardType="numeric"
                      />
                    </div>
                    {errorText !== "" && <p>{errorText}</p>}
                  </div>

                  <Button
                    className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
                    onClick={handleCollectPayment}
                    disabled={isPayNowButtonPressed}
                  >
                    <p className=" w-full text-2xl font-semibold flex justify-content-center">
                      Generate Payment Link
                    </p>
                  </Button>
                </div>
              )}
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default PaymentGatewayLinkGenerateModalAdmin;
